export class WrongBilledDialogModel {
    constructor(
        public item: any
    ) {}
  }